/* eslint-disable max-lines */
import mInput from '../Input';
import postInput from '@/components/lots/otpAdvance';
import MSelect from '@/components/lots/otpSelect2';
import { filePreview } from '@/utils/filePreview.js';
import bigDataLog from '@/utils/bigDataLog';
import { quotedList, isMaintainTem, delTemList, modifyList, saveTempalte, bidPrice,
    blockPrice, templateInfo, isFlower, seachPrice, uploadList, exportLine, exportBidQuote, exportBidQuoteJSON } from '../../../../../../lsrm/api/bidScheme.js';
import { tenderEnquiry } from '../../../../../../lsrm/api/tenderEnquiry';
import mImport from '../../../../../components/importFile/Import2.vue';
import { mapGetters } from 'vuex';
// import config from '@/config/user.env';
import privilegeDialog from '../privilegeDialog.vue';
import MoreRuleButtons from '../MoreRuleButtons.vue';
import MoreRuleTables from '../MoreRuleTables.vue';
import { vbtTable, vbtTableColumn } from 'vbt-table';
import { dictWithUrl } from '@/components/lots/api';
import { SRM_FILE_PRE } from '../../../../../constant/constant.js';

export const IS_MORE_RULE = { YES: 1, NO: 0 }; // 是否多规则模板

export default {
    components: { mInput, mImport, postInput, privilegeDialog, vbtTable, vbtTableColumn, MoreRuleButtons, MoreRuleTables,MSelect },
    props: {
        TodoPath: {
            type: String
        }
    },
    data() {
        return {
            dictData: {},
            mbpmFlowId: '',
            loadSave: false,
            loadPrice: false,
            loadDelete: false,
            allSelect: false,
            selectAllType: false,
            templateForm: {
                templateCode: '',
                // templateDesc: '',
                templateName: '',
                priceBarb: ''
            },
            files: {}, // 模板说明文件
            bidData: {},
            delBtn: false,
            importQuotationBtn: false, // 导入报价模板按钮
            exportBtn: false, // 导出按钮
            isMaintainT: false, // 是否模板是否维护
            isPublish: '',
            isExamine: '',
            isPrice: true,
            privilegeButton: true,
            changeSeq: '', // 点击特权修改按钮时间戳
            changeReson: '', // 特权修改理由
            isPrivilege: false, // 是否点击了特权修改按钮
            showPrivilegeDialog: false,
            delList: [], // 需要删除的行
            dbCheckId: '', // 标记行被点击的id
            currentRow: null, // 高亮的行
            loading: true,
            tableData: [],
            table: [],
            customList: [],
            chargTemplate: { // 模板选择
                value: 'templateName',
                advanceConfig: [
                    { prop: 'templateCode', value: '模板编码' },
                    { prop: 'templateName', value: '模板名称' }
                    // { prop: 'templateDesc', value: '模板规则' }
                ],
                advanceUrl: '/bid/bidQuoteTmptHeader/getAllBidQuoteTmpInfo',
                prefix: '/api-srm-web',
                name: '价格模板',
                tableConfig: [
                    { prop: 'templateCode', value: '模板编码',width:'160' },
                    { prop: 'templateName', value: '模板名称',width:'auto' },
                    { prop: '_priceBarb', value: '是否防倒挂' ,width:'160'}
                    // { prop: 'templateDesc', value: '模板规则' }
                ],
                cbParams: ['templateCode', 'templateName', 'calRuleCode', 'childList', 'isMoreRule', 'moreRuleChildList','priceBarb']
            },
            formerSupplierData: { // 老供应商
                value: 'supplierCode',
                advanceConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' }
                ],
                advanceUrl: '/supplier/supplierInfo/query/bid',
                prefix: '/api-srm-web',
                cbParams: ['supplierCode', 'supplierNameCn', 'tansType'],
                name: '老供应商',
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                    { prop: 'tansType', value: '承运商类别' }
                ]
            },
            exporDetailtURl: `${SRM_FILE_PRE}/bid/quoteTemplate/exportBidQuoteTemplate`, // 导出明细
            exportTemplateURl: `${SRM_FILE_PRE}/bid/quoteTemplate/exportBidQuoteTemplateHeader`, // 导出模板
            uploadUrl: `${SRM_FILE_PRE}/bid/quoteTemplate/importBidQuoteTemplateHeader`, // 导入报价模板
            uploadParams: {},
            uploadPriceUrl: `${SRM_FILE_PRE}/bid/quoteTemplate/bidPriceBidQuoteTemplateHeader`, // 导入拦标价
            etLoading: false,
            edLoading: false,
            elLoading: false,
            eaLoading: false,
            iflowId: this.$route.query.mbpmFlowId,
            isMoreRule: null // 是否多规则模板
        };
    },
    mounted() {
        dictWithUrl('REPORT_LCP_DC_LINE,REPORT_LCP_DC_PLACE').then(item => {
            this.dictData = item.data;
        });
        this.init();
    },
    methods: {
        async getFile() { // 获取模板文件说明
            if(!this.templateForm.templateCode){
             return
            }
            const res = await uploadList({ moduleNo: this.templateForm.templateCode });
            if (res && res.code === '0') {
                if (res.data) {
                    this.files = res.data.list[0];
                } else { this.files = {}; }
            }
        },
        downFile() { window.location = this.files.fileUrl; },
        preview() { filePreview(this.files); },
        handleCommand(command) { /** 导出 **/
            const operateObj = {
                LINE: { loading: 'elLoading', bigDataClass: 'bigData-btn-quotedTemp-exRoute' },
                ADMINISTRATIVE: { loading: 'eaLoading', bigDataClass: 'bigData-btn-quotedTemp-exPlan' },
                TEMMPLATE: {
                    fileName: this.bidData.bidName + '-报价模板.xlsx',
                    url: this.exportTemplateURl,
                    loading: 'etLoading',
                    bigDataClass: 'bigData-btn-quotedTemp-exTemp'
                },
                DETAIL: {
                    fileName: this.bidData.bidName + '-报价详情.xlsx',
                    url: this.exporDetailtURl,
                    loading: 'edLoading',
                    bigDataClass: 'bigData-btn-quotedTemp-exDetail'
                }
            };
            // 线路 or 行政区域
            if (command === 'LINE' || command === 'ADMINISTRATIVE') {
                const key = command === 'LINE' ? 'REPORT_LCP_DC_LINE' : 'REPORT_LCP_DC_PLACE';
                this[operateObj[command]['loading']] = true;
                exportLine(this.dictData[key]).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('导出成功！请留意右上角文件中心下载文件！');
                    }
                }).finally(() => { this[operateObj[command]['loading']] = false; });
            } else if (command === 'TEMMPLATE') {
                this[operateObj[command]['loading']] = true;
                exportBidQuoteJSON(operateObj[command].url, this.$route.query.bidNo, this.templateForm.templateCode).then(res => {
                    if (res && +res.code === 0) {
                        var a = document.createElement('a');
                        a.href = res.data.downUrl;
                        a.download = operateObj[command].fileName;
                        a.click();
                        // document.removeChild(a);
                        this.$message.success('导出成功');
                    }
                }).finally(() => { this[operateObj[command]['loading']] = false; });
            } else {
                this[operateObj[command]['loading']] = true;
                exportBidQuote(operateObj[command].url, this.$route.query.bidNo, this.templateForm.templateCode).then(res => {
                    if (res) {
                        const blob = new Blob([res], {
                            // type: 'application/x-excel;charset=UTF-8'
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        const objectUrl = URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.href = objectUrl;
                        a.download = operateObj[command].fileName;
                        a.click();
                        // document.removeChild(a);
                        this.$message.success('导出成功');
                    }
                }).finally(() => { this[operateObj[command]['loading']] = false; });
            }
            bigDataLog.sendDetailMessageByKey(operateObj[command]['bigDataClass']);
        },
        dblClick(item, e) { // 双击表格
            item.edit = true;
            this.dbCheckId = item.id;
        },
        handClick(item) { // 单击表格
            var reg = RegExp(/new/);
            item.isCheck = true;// 只要被点击过的行就算被修改过
            item.bidType = this.bidData.bidType;
            this.tableData.forEach(item => {
                item.edit = false;
            });
            if (item.id === this.dbCheckId || reg.test(item.id)) {
                item.edit = true;
            }
            this.dbCheckId = item.id;
        },
        handleCurrentChange(val) { // 获取高亮的行
            this.currentRow = val;
        },
        exportTip() { // 没选规则时导出的提示
            this.$message.error('当前不能操作');
        },
        getformerSupplier(val, row) {
            row.formerSupplierName = val.supplierNameCn;
            row.formerSupplierCode = val.supplierCode;
        },
        async deleteTemplate() { // 删除
            if (this.isMoreRuleTemplate) {
                this.$refs.moreRuleTables.deleteTemplate();
                return false;
            }
            this.delList = [];
            const tableBel = this.tableData.filter(item => { return !item.quoteCodeParent; });
            tableBel.forEach(item => {
                if (item.isSelect) { this.delList.push(item); } else {
                    if (item.childList) {
                        item.childList.forEach(item2 => {
                            if (item2.isSelect) {
                                this.delList.push(item2);
                            }
                        });
                    }
                }
            });
            var reg = RegExp(/new/);
            const arr = [];
            this.delList.forEach(item => {
                if (reg.test(item.id) === false) {
                    const obj = { id: item.id, quoteCode: item.quoteCode, quoteCodeParent: item.quoteCodeParent, bidNo: this.$route.query.bidNo };
                    arr.push(obj);
                }
            });
            if (this.delList.length === 0) {
                this.$message.warning('没有选中数据');
            } else {
                this.$confirm('是否确定要删除选择的数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    this.loadDelete = true;
                    let url = '';// 判断是否特权修改，是的话加上特定参数
                    if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }// 判断是否特权修改，是的话加上特定参数
                    const res = await delTemList(url, arr);
                    this.loadDelete = false;
                    if (res && res.code === '0') {
                        this.init(false);
                        this.$message.success('操作成功');
                        if (!this.currentRow || this.currentRow.quoteCodeParent === null) { // 删除父节点后，还能添加父节点
                            this.currentRow = null;
                        }
                    }
                }).catch(() => {});
            }
        },
        expectTrafficDecide(i) {
            for (let k = 0; k < this.table[i].childList.length; k++) {
                if (this.table[i].childList[k].expectTraffic * 1 <= 0 || this.table[i].childList[k].expectTraffic === null) {
                    this.$message.warning(`第${this.table[i].childList[k].rowNumber}行预计业务量不能小于0`);// 子节点预计业务量小于0
                    return false;
                }
            }
        },
        relationDecide(i) {
            for (let k = 0; k < this.table[i].childList.length; k++) {
                if (this.table[i].childList[k].bidLevel * 1 <= this.table[i].childList[k].relationLevel * 1) {
                    this.$message.warning(`第${this.table[i].childList[k].rowNumber}行关联排序号不能大于或等于排序号`);// 子节点关联排序号不能等于排序号
                    return false;
                }
            }
        },
        privilegeClick() { // 特权修改
            this.showPrivilegeDialog = true;
        },
        privilegeConfirm(value) {
            this.importQuotationBtn = true;
            this.delBtn = true;
            this.isPrivilege = true;
            if (this.bidData.blockPriceControl === 'Y') { this.isPrice = true; }
            this.changeSeq = new Date().getTime() + this.$route.query.bidNo;
            this.changeReson = value;
            const url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`;
            this.uploadUrl = `${SRM_FILE_PRE}/bid/quoteTemplate/importBidQuoteTemplateHeader${url}`;
            this.uploadPriceUrl = `${SRM_FILE_PRE}/bid/quoteTemplate/bidPriceBidQuoteTemplateHeader${url}`;
        },
        async saveList() { // 保存
            if (this.isMoreRuleTemplate) {
                this.$refs.moreRuleTables.saveList();
                return false;
            }
            for (let i = 0; i < this.table.length; i++) { // 预计业务量校验
                if (this.table[i].expectTraffic * 1 <= 0 || this.table[i].expectTraffic === null) {
                    this.$message.warning(`第${this.table[i].rowNumber}行预计业务量不能小于0`);// 父节点预计业务量小于0
                    return false;
                } else if (this.table[i].childList) {
                    const expectTrafficRes = this.expectTrafficDecide(i);
                    if (expectTrafficRes === false) {
                        return false;
                    }
                }
            }
            if (this.bidData.ralationQuote === 'Y') { // 关联排序号不能等于排序号
                for (let i = 0; i < this.table.length; i++) {
                    if (this.table[i].bidLevel * 1 <= this.table[i].relationLevel * 1) {
                        this.$message.warning(`第${this.table[i].rowNumber}行关联排序号不能大于或等于排序号`);// 父节点关联排序号不能等于排序号
                        return false;
                    } else if (this.table[i].childList) {
                        const relationRes = this.relationDecide(i);
                        if (relationRes === false) {
                            return false;
                        }
                    }
                }
            }
            if (this.bidData.blockPriceControl === 'Y') { // 拦标价高不能低于拦标价低
                for (let i = 0; i < this.table.length; i++) {
                    if (this.table[i].quoteRangeMin * 1 > this.table[i].quoteRangeMax * 1) { // 父节点拦标价高不能低于拦标价低
                        this.$message.warning(`第${this.table[i].rowNumber}行拦标价高不能低于拦标价低`);
                        return false;
                    } else if (this.table[i].childList) {
                        for (let k = 0; k < this.table[i].childList.length; k++) { // 子节点拦标价高不能低于拦标价低
                            if (this.table[i].childList[k].quoteRangeMin * 1 > this.table[i].childList[k].quoteRangeMax * 1) {
                                this.$message.warning(`第${this.table[i].childList[k].rowNumber}行拦标价高不能低于拦标价低`);
                                return false;
                            }
                        }
                    }
                }
            }
            var reg = RegExp(/new/);
            const arr = [];
            this.table.forEach((item, index) => {
                if (item.isCheck) {
                    arr.push(item);
                }
            });
            arr.forEach(item => {
                if (reg.test(item.id)) {
                    delete item.id;
                }
                if (item.childList) {
                    item.childList.forEach((it, index) => {
                        if (reg.test(it.id)) {
                            delete it.id;
                        }
                        if (it.quoteRangeMax === '*' || it.quoteRangeMin === '*') {
                            it.quoteRangeMax = null;
                            it.quoteRangeMin = null;
                        }
                    });
                    var newChildList = item.childList.filter(function (item) {
                        return item.isCheck;
                    });
                    item.templatesList = newChildList;
                    delete item.childList;
                }
            });
            this.loadSave = true;
            let url = '';// 判断是否特权修改，是的话加上特定参数
            if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }// 判断是否特权修改，是的话加上特定参数
            const res = await modifyList(url, arr);
            this.loadSave = false;
            if (res && res.code === '0') {
                this.init(false);
                this.$message.success('操作成功');
            }
        },
        async markThePrice() { // 拦标价审批
            const priceBlock = await seachPrice(this.$route.query.bidNo);
            if (!priceBlock.data) {
                this.$message.warning('拦标价未维护');
                return;
            }
            const flowerRes = await isFlower({ bussinessCode: this.$route.query.bidNo, auditType: '4' });// 判断是否有流程
            if (flowerRes.data.list.length !== 0) { // 有流程
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        noticeCode: this.$route.query.bidNo,
                        processId: flowerRes.data.list[0].fdId,
                        formInstanceId: this.$route.query.bidNo,
                        mbpmFlowId: this.iflowId,
                        isBack: true,
                        path: 'bidScheme'
                    }
                });
            } else { // 没有流程发起流程
                let strUrl = '';
                strUrl = location.origin + location.pathname + `#/tenderdocument/tenderdocument?bidNo=${this.$route.query.bidNo}&defaultComponent=quotedTemplate`;
                const res = await bidPrice({
                    tenantCode: this.currentTenant.tenantCode,
                    appCode: this.applicationCode,
                    fdTemplateCode: 'srm_bid_head_hurdles',
                    loginName: this.$store.getters.user.userCode,
                    formParam: {
                        subject: this.$route.query.bidNo + '_' + this.bidData.bidName + '_拦标价审批_' + this.$store.getters.user.userName,
                        formInstanceId: this.$route.query.bidNo,
                        fdUrl: strUrl
                    }
                });
                if (res && res.code === '0') {
                    this.$router.push({
                        name: 'mipIframe',
                        query: {
                            isBack: true,
                            path: 'bidScheme',
                            mbpmFlowId: this.iflowId,
                            noticeCode: this.$route.query.bidNo,
                            formInstanceId: this.$route.query.bidNo,
                            processId: res.data.fdId
                        }
                    });
                }
            }
        },
        expandRow(row) { row.isCheck = true; },
        publishPrice() { // 公布拦标价
            this.$confirm('拦标价公布后，所有成员及供应商则可查看，请确认是否公布', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.loadPrice = true;
                const res = await blockPrice({ id: this.bidData.id, version: this.bidData.version });
                this.loadPrice = false;
                if (res && res.code === '0') {
                    this.init(false);
                    this.$message.success('操作成功');
                }
            }).catch(() => {});
        },
        success() { // 导入成功后的回调
            // this.init(false);
        },
        haveSafeguard() { // 已经维护点击弹框
            this.$message.warning('报价模板已经维护了数据，不能修改招标模板，请先删掉报价模板明细，再修改招标模板');
        },
        async init(temp = true) {
            const bidNo = this.$route.query.bidNo
            if (this.iflowId && this.mipNum === 1) {
                this.$store.commit('setMipNum', this.mipNum + 1)
                const path = location.hash.replace('#', '')
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        processId: this.iflowId,
                        path,
                    }
                });
            }
            const bidRes = await tenderEnquiry({ bidNo: this.$route.query.bidNo,iflowId: this.iflowId });
            this.bidData = bidRes.data.list[0];// 获取招标维护数据
            // 带出招标模板等信息
            if (temp) {
                const tempInfo = await templateInfo({ bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                if (tempInfo && tempInfo.code === '0' && tempInfo.data) {
                    // 获取自定义列字段
                    this.customList = tempInfo.data.childList;
                    this.templateForm.templateName = tempInfo.data.templateName;
                    this.templateForm.templateCode = tempInfo.data.templateCode;
                    this.templateForm.priceBarb = tempInfo.data.priceBarb;
                    // this.templateForm.templateDesc = tempInfo.data.templateDesc;
                    this.getFile();
                    this.isMoreRule = tempInfo.data.isMoreRule;
                }
            }
            this.setButtonDisable();
            if (!this.isMoreRuleTemplate) {
                let rowNumber = 0;
                // 获取非多规则模板表格数据
                const res = await quotedList({ bidNo: this.$route.query.bidNo, iflowId: this.iflowId  });
                this.loading = false;
                if (res && res.code === '0') {
                    this.tableData = res.data;
                    this.table = this.tableData.filter(item => { return !item.quoteCodeParent; });
                    this.tableData.forEach(item => {
                        rowNumber++;
                        item.rowNumber = rowNumber;
                        this.$set(item, 'edit', false);
                        this.$set(item, 'showSubTable', false);
                        this.$set(item, 'isSelect', false);
                        if (item.childList) {
                            item.childList.forEach(it => {
                                rowNumber++;
                                it.rowNumber = rowNumber;
                                this.$set(it, 'edit', false);
                                this.$set(it, 'isSelect', false);
                            });
                        }
                    });
                }
            } else {
                this.$nextTick(() => {
                    this.$refs.moreRuleTables.getData(temp);
                });
            }
            const isMaintainRes = await isMaintainTem({ bidNo });// 判断模板是否维护
            if (isMaintainRes && isMaintainRes.code === '0') {
                if (isMaintainRes.data) {
                    this.isMaintainT = true; // 已维护
                } else {
                    this.isMaintainT = false;
                    this.loading = false;
                }
            }
        },
        // 根据条件置灰操作按钮
        setButtonDisable() {
            if (this.bidData.bidStatus === '00' || this.bidData.bidStatus === '20') { // 删除、新增、保存按钮控制: 00 新建，20 标书驳回
                this.delBtn = true;
            } else {
                this.delBtn = false;
            }
            if ((this.bidData.bidStatus === '30' || this.bidData.bidStatus === '40' || this.bidData.bidStatus === '43') && this.bidData.blockPriceControl === 'Y') { // 拦标价审批按钮
                this.isExamine = true;
            } else {
                this.isExamine = false;
            }
            if ((this.bidData.bidStatus === '30' || this.bidData.bidStatus === '40' || this.bidData.bidStatus === '43') && this.bidData.blockPriceControl === 'Y') { // 导入拦标价
                if (this.bidData.quoteRangeVisible === '2' || this.bidData.quoteRangeVisible === '4') {
                    this.isPrice = false;
                } else {
                    this.isPrice = true;
                }
            } else {
                this.isPrice = false;
            }
            // 50: 标书发布
            if (this.bidData.bidStatus === '50' && this.bidData.blockPriceControl === 'Y') { // 公布拦标价按钮控制
                this.isPublish = true;
            } else {
                this.isPublish = false;
            }
            // 30: 标书通过, 40: 综合评分中, 43: 综合评分完成
            if (this.bidData.bidStatus >= '30' && this.bidData.bidStatus <= '43') { // 特权修改按钮控制
                this.privilegeButton = true;
            } else { this.privilegeButton = false; }
            if (this.isPrivilege) {
                this.importQuotationBtn = true;
                this.delBtn = true;
                if (this.bidData.blockPriceControl === 'Y') { this.isPrice = true; }
            }
        },
        // TODO: 需要处理多规则渲染
        async getAdvanceValue(val) {
            this.customList = [];
             this.templateForm.templateName = val.templateName;
            let saveRes = await  saveTempalte({
                templateCode: val.templateCode,
                templateName: val.templateName,
                bidNo: this.$route.query.bidNo
            })
            if (!saveRes){
                this.templateForm.templateName = '';
                this.templateForm.templateCode = '';  
                return
            }
            if (val.isMoreRule === IS_MORE_RULE.NO && val.childList) {
                this.customList = val.childList;
            }
            this.templateForm.templateCode = val.templateCode;
            this.templateForm.priceBarb = val.priceBarb;
    
            this.getFile();

            this.isMoreRule = val.isMoreRule;
            if (this.isMoreRuleTemplate) {
                const list = val.calRuleCode.split(',').map(code => {
                    return val.moreRuleChildList.find(item => item.ruleCode === code);
                });
                this.$nextTick(() => {
                    this.$refs.moreRuleTables.changeRuleTemp(list);
                });
            }
        },
        tableRowClassName({ row, rowIndex }) { // 表单颜色
            var reg = RegExp(/new/);
            if (reg.test(row.id)) {
                return 'warning-row';
            }
            if (this.bidData.ralationQuote === 'Y' && !row.relationLevel && row.quoteCodeParent) {
                return 'price-row';
            }
        },
        showDetail(row) {
            row.isCheck = true;
            row.showSubTable = !row.showSubTable;
            const index = this.tableData.indexOf(row);
            if (row.showSubTable) { // 展开
                this.tableData.splice(index + 1, 0, ...row.childList);
            } else { // 缩回
                this.tableData.splice(index + 1, row.childList.length);
            }
        },
        commonAll() {
            var count = 0;
            for (let i = 0; i < this.table.length; i++) {
                if (this.table[i].isSelect) { count++; }
            }
            if (count === this.table.length) {
                this.selectAllType = true;
            } else { this.selectAllType = false; }
        },
        commonParent(row) { // 子节点勾选时，判断父节点
            const table = this.table.filter(item => { return row.quoteCodeParent === item.quoteCode; });
            let count = 0;
            table[0].childList.forEach(item => {
                if (item.isSelect) { count++; }
            });
            if (count === table[0].childList.length) {
                table[0].isSelect = true;
            } else { table[0].isSelect = false; }
        },
        selectOne(row, val) { // 父节点勾选框;
            row.edit = false;
            row.isSelect = val;
            if (row.childList) {
                row.childList.forEach(item => {
                    item.isSelect = val;
                });
            }
            this.commonAll();
        },
        selectTwo(row, val) { // 子节点勾选框
            row.edit = false;
            row.isSelect = val;
            this.commonParent(row);
            this.commonAll();
        },
        selectAll(row, val) {
            this.tableData.forEach(item1 => {
                item1.isSelect = val;
                if (item1.childList) {
                    item1.childList.forEach(item2 => {
                        item2.isSelect = val;
                    });
                }
            });
            this.selectAllType = val;
        },
        handleRefresh() {
            this.init(false);
        }

    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        // 是否多规则模板
        isMoreRuleTemplate() {
            return +this.isMoreRule === IS_MORE_RULE.YES;
        },
        mipNum() {
            return this.$store.state.mipNum
        },
    },
    watch: {
        templateForm: {
            handler(newVal) { // 导入报价模板
                if (this.templateForm.templateCode && (this.bidData.bidStatus === '00' || this.bidData.bidStatus === '20')) {
                    this.importQuotationBtn = true;
                } else { this.importQuotationBtn = false; }
                this.uploadParams = {
                    bidNo: this.$route.query.bidNo,
                    templateCode: this.templateForm.templateCode,
                    bidType: this.bidData.bidType
                };
                if (this.templateForm.templateCode) { // 要选择报价模板后才能导出
                    this.exportBtn = true;
                } else {
                    this.exportBtn = false;
                }
            },
            deep: true
        },
        TodoPath(val) {
            if (!val) {
                this.markThePrice();
            }
        }
    }
};